import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactFormGroup } from './model/contact-form-group';
import { ContactIntakeService } from './contact-intake.service';
import { ContactIntakeUtilsService } from './contact-intake-utils.service';
import { catchError, EMPTY, finalize, of, take, tap } from 'rxjs';
import { ToastService } from '../../core/service/toast.service';

@Component({
  selector: 'app-contact-intake',
  templateUrl: './contact-intake.component.html',
  styleUrls: ['./contact-intake.component.css'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class ContactIntakeComponent {
  contactFormGroup: FormGroup<ContactFormGroup>;
  saving = false;

  constructor(
    private contactIntakeService: ContactIntakeService,
    private toastService: ToastService,
  ) {
    this.contactFormGroup = ContactIntakeUtilsService.createFormGroup();
  }

  get firstname(): FormControl<string> {
    return this.contactFormGroup.controls.firstname;
  }

  get isFirstnameInvalid(): boolean {
    const control = this.contactFormGroup.controls.firstname;
    return control && control.invalid && (control.dirty || control.touched);
  }

  get lastname(): FormControl<string> {
    return this.contactFormGroup.controls.lastname;
  }

  get isLastnameInvalid(): boolean {
    const control = this.contactFormGroup.controls.lastname;
    return control && control.invalid && (control.dirty || control.touched);
  }

  get phone(): FormControl<string> {
    return this.contactFormGroup.controls.phone;
  }

  get isPhoneInvalid(): boolean {
    const control = this.contactFormGroup.controls.phone;
    return control && control.invalid && (control.dirty || control.touched);
  }

  get email(): FormControl<string> {
    return this.contactFormGroup.controls.email;
  }

  get isEmailInvalid(): boolean {
    const control = this.contactFormGroup.controls.email;
    return control && control.invalid && (control.dirty || control.touched);
  }

  send(): void {
    this.toastService.clear();
    ContactIntakeUtilsService.touchAll(this.contactFormGroup);
    if (this.contactFormGroup.valid) {
      this.saving = true;
      this.contactIntakeService
        .saveContact(this.contactFormGroup.value)
        .pipe(
          take(1),
          tap(() => this.contactFormGroup.reset(ContactIntakeUtilsService.defaultFormSettings)),
          finalize(() => (this.saving = false)),
          catchError(() => of(EMPTY)),
        )
        .subscribe();
    } else {
      this.toastService.error({
        message: 'Bitte alle Pflichtfelder richtig ausfüllen.',
      });
    }
  }
}
